export default __webpack_public_path__ + "static/15-ca55b6d47339039993ab4ac73dbf7ada.jpg";